const TOKEN_KEY = 'TOKEN';
let ALLOWED_APPLICATION_ID = 'BACKOFFICE';

type callback = (token: string | undefined) => void;
export type TokenMetadata = {
    applicationId: string;
    branchId: number;
    delay: number;
    exp: number;
    iat: number;
    kycId: number;
    login: string;
};

let onTokenUpdateCallbacks: callback[] = [];

export const getToken = (): string | undefined => {
    const token = window.localStorage.getItem(TOKEN_KEY);
    return token || undefined;
};

export const setToken = (token: string): void => {
    window.localStorage.setItem(TOKEN_KEY, token);
    onTokenUpdateCallbacks.forEach(c => c(token));
};

export const removeToken = (): void => {
    window.localStorage.removeItem(TOKEN_KEY);
    onTokenUpdateCallbacks.forEach(c => c(undefined));
};

export const attachTokenUpdateCallback = (c: callback): void => {
    onTokenUpdateCallbacks.push(c);
};

export const detachTokenUpdateCallback = (c: callback): void => {
    onTokenUpdateCallbacks = onTokenUpdateCallbacks.filter(cb => cb !== c);
};

export const readToken = (token: string): TokenMetadata => {
    const tokenParts: string[] = token.split('.');
    if (tokenParts.length === 3) {
        const tokenPayload = atob(tokenParts[1]);
        return JSON.parse(tokenPayload);
    }
    throw new Error(`Badly formed token: ${token}`);
};

/**
 * Set a regex to match application id from token
 * @param applicationId regex to match allowed application IDs
 */
export const setAllowedApplicationId = (applicationId: string): void => {
    ALLOWED_APPLICATION_ID = applicationId;
};

export const isTokenValid = (token: string): boolean => {
    try {
        const metadata: TokenMetadata = readToken(token);
        const currentTime = new Date().getTime();
        const expirationTime = metadata.exp * 1000;
        return currentTime < expirationTime && tokenMatch(metadata.applicationId);
    } catch (e) {
        return false;
    }
};

export const checkTokenValidity = async (): Promise<void> => {
    const token = getToken();
    if (token === undefined || !isTokenValid(token)) {
        // If the token is undefined, call the remove token anyway,
        // so it will trigger the callbacks
        removeToken();
    }
};

setInterval(checkTokenValidity, 5000);

const tokenMatch = (applicationId: string): boolean => {
    const regex = new RegExp(ALLOWED_APPLICATION_ID);
    return regex.test(applicationId);
};
